import * as React from 'react';
import { Row, Button, Tabs, Tab } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { flow, filter } from 'lodash';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { IAuthActions, IAuthState } from '../../../../services/auth/models';
import { actions as authActions } from '../../../../services/auth/reducer';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { actions as brandingActions } from '../../../../services/branding/reducer';
import { IQuoteActions } from '../../../../services/quote/models';
import { IBrandingActions, IBrandingState } from '../../../../services/branding/models';
import { reset, destroy } from 'redux-form';
import Loading from '../../../../components/Loading';
import { withJob } from 'react-jobs';
import { IPolicy, IPolicyApplication } from '../../../../data/api/models';
import { IStore } from '../../../../redux/IStore';

interface IAccountSummaryProps {
  auth: IAuthState;
  actions: {
    push: (route: string) => void;
    auth: IAuthActions;
    branding: IBrandingActions,
    quote: IQuoteActions;
    reset(formName: string);
    destroy(formName: string);
  };
  branding?: IBrandingState;
}

interface IAccountSummaryState {
  activeTab: number;
}

class AccountSummary extends React.Component<IAccountSummaryProps, IAccountSummaryState> {
  constructor(props) {
    super(props);

    const defaultTab = 1;

    this.state = {
      activeTab: defaultTab,
    };

  }

  private renderPolicyData = (cell, row) => {
    return (
      <Link to={`/account/policies/${row.id}`}>
        {cell}
      </Link>
    );
  }

  private renderQuoteData = (cell, row) => {
    return (
      <Link to={`/account/quotes/${row.id}`}>
        {cell}
      </Link>
    );
  }

  private renderRenewalsData = (cell, row) => {
    return (
      <Link to={`/account/renewals/${row.id}`}>
        {cell}
      </Link>
    );
  }

  private handleGetNewQuote = () => {
    const { actions, branding } = this.props;
    const loadQuoteProcess = () => {
      actions.destroy('quote');
      actions.quote.reset();
      actions.quote.loadDestinations();
      actions.push('/');
    };

    loadQuoteProcess();
  }

  private handleTab = (key) => {
    this.setState({
      activeTab: key,
    });
  }

  public render() {

    const { auth, actions, branding } = this.props;

    if (!branding || !branding.channel.name) {
      return null;
    }

    const policyApplications = filter(
      auth.customer.policyApplications,
      (application: IPolicyApplication) => {
        return application.status !== 'renewal' &&
          application.status !== 'renewal invited' &&
          application.status !== 'customer lapsed' &&
          application.quoteType !== 'mid term adjustment' &&
          (application.channelName === branding.channel.name ||
            application.channelName === 'B2B');
      },
    );

    const policiesForChanel = filter(auth.customer.policies, (policy: IPolicy) => {
      return policy.channelName === branding.channel.name || policy.channelName === 'B2B';
    });

    return (
      <Row className="page-container">
        <div className="customer-section-title">
          <h1>Welcome {auth.customer.firstName}.</h1>
        </div>
        <Tabs
          defaultActiveKey={1}
          id="your-account-tabs"
          className="your-account-tabs"
          onSelect={this.handleTab}
        >
          <Tab eventKey={1} title="Policies">
            <div className="white-section customer-table">
              <BootstrapTable data={policiesForChanel}>
                <TableHeaderColumn
                  dataField="policyNumber"
                  isKey={true}
                  width="20%"
                  dataSort={true}
                  dataFormat={this.renderPolicyData}
                >
                  Reference
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="insured"
                  width="20%"
                  dataSort={true}
                  dataFormat={this.renderPolicyData}
                >
                  Insured
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="commencesAt"
                  width="20%"
                  dataSort={true}
                  dataFormat={this.renderPolicyData}
                >
                  Starts
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="expiresAt"
                  width="20%"
                  dataSort={true}
                  dataFormat={this.renderPolicyData}
                >
                  Ends
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="status"
                  width="20%"
                  dataSort={true}
                  dataFormat={this.renderPolicyData}
                >
                  State
                </TableHeaderColumn>
              </BootstrapTable>
            </div>
          </Tab>
          <Tab eventKey={2} title="Quotes">
            <div className="white-section customer-table">
              <BootstrapTable
                data={policyApplications}
              >
                <TableHeaderColumn
                  dataField="quoteReference"
                  isKey={true}
                  width="20%"
                  dataSort={true}
                  dataFormat={this.renderQuoteData}
                >
                  Reference
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="insured"
                  width="20%"
                  dataSort={true}
                  dataFormat={this.renderQuoteData}
                >
                  Insured
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="startDate"
                  width="20%"
                  dataSort={true}
                  dataFormat={this.renderQuoteData}
                >
                  Starts
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="endDate"
                  width="20%"
                  dataSort={true}
                  dataFormat={this.renderQuoteData}
                >
                  Ends
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="status"
                  width="20%"
                  dataSort={true}
                  dataFormat={this.renderQuoteData}
                >
                  State
                </TableHeaderColumn>
              </BootstrapTable>
            </div>
          </Tab>
          {auth.customer.renewals.length > 0 && branding.channel.showRenewalTab && (
            <Tab eventKey={3} title="Renewals">
              <div className="white-section customer-table">
                <BootstrapTable
                  data={auth.customer.renewals}
                >
                  <TableHeaderColumn
                    dataField="quoteReference"
                    isKey={true}
                    width="20%"
                    dataSort={true}
                    dataFormat={this.renderRenewalsData}
                  >
                    Reference
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="insured"
                    width="20%"
                    dataSort={true}
                    dataFormat={this.renderRenewalsData}
                  >
                    Insured
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="startDate"
                    width="20%"
                    dataSort={true}
                    dataFormat={this.renderRenewalsData}
                  >
                    Starts
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="endDate"
                    width="20%"
                    dataSort={true}
                    dataFormat={this.renderRenewalsData}
                  >
                    Ends
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="status"
                    width="20%"
                    dataSort={true}
                    dataFormat={this.renderRenewalsData}
                  >
                    State
                  </TableHeaderColumn>
                </BootstrapTable>
              </div>
            </Tab>)
          }
        </Tabs>
        <hr/>
        <div className="flex-btn-bar">
          {/*<Button
            bsStyle="default"
            type="submit"
            bsSize="lg"
          >
            CHANGE PASSWORD
          </Button>*/}
          <Button
            bsStyle="default"
            type="submit"
            bsSize="lg"
            onClick={actions.auth.logout}
          >
            LOG OUT
          </Button>
          <Button
            bsStyle="primary"
            bsSize="lg"
            className="pull-right"
            onClick={this.handleGetNewQuote}
          >
            NEW QUOTE
          </Button>
        </div>
      </Row>
    );
  }
}

export default flow([
  // reduxForm({
  //   form: 'quote',
  // destroyOnUnmount: true,
  // forceUnregisterOnUnmount: true,
  // }),
  withJob({
    work: (props: IAccountSummaryProps) => {
      const promises = [];

      promises.push(props.actions.auth.reloadCustomer());

      return Promise.all(promises);
    },
    LoadingComponent: (props) => <Loading/>,
    ErrorComponent: ({ error }) => {
      console.error(error);

      return (
        <div>
          {error.message}
        </div>
      );
    },
  }),
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
        quote: state.quote,
        branding: state.branding,
      };
    },
    (dispatch) => ({
      actions: {
        auth: bindActionCreators({ ...authActions }, dispatch),
        push: bindActionCreators(push, dispatch),
        reset: bindActionCreators(reset, dispatch),
        destroy: bindActionCreators(destroy, dispatch),
        quote: bindActionCreators({ ...quoteActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
      },
    }),
  ),
])(AccountSummary);
